import { useAtom } from "jotai";
import {
  EndDateAtom,
  ExtraGoalAtomsAtom,
  ExtraGoalsAtom,
  StartDateAtom
} from "./atoms";
import * as React from "react";
import { ExtraField } from "./extraField";
import { PredefinedField } from "./predefinedField";

import * as strings from "./strings";
import { useNav } from "./useNav";
import { DateRangePicker } from "react-next-dates";
import { enUS } from "date-fns/locale";

const {
  back_string,
  next_string,
  step4_title,
  step1_period_label,
  step4_intro,
  step1_addextra_string,
  step1_predefinedgoals,
  step4_bottom_text,
    step4_goal_title
} = strings;
export function Step4() {
  const { prev, next } = useNav();
  const [extraFieldAtoms, removeExtraField] = useAtom(ExtraGoalAtomsAtom);
  const [, setExtraFields] = useAtom(ExtraGoalsAtom);
  const [startDate, setStartDate] = useAtom(StartDateAtom);
  const [endDate, setEndDate] = useAtom(EndDateAtom);

  return (
    <>
      <div className="atc-step-header">
        <p className="at-tagline">Step 4 / 4</p>
        <h2 className="at-title">{step4_title}</h2>
        <div
          className="at-text"
          dangerouslySetInnerHTML={{ __html: step4_intro }}
        />
      </div>
      <div className="atc-row">
        <div className="atc-label">{step1_period_label}</div>
        <div className="atc-split-row">
          <DateRangePicker
            locale={enUS}
            startDate={startDate}
            endDate={endDate}
            onStartDateChange={setStartDate}
            onEndDateChange={setEndDate}
            portalContainer={document.body}
          >
            {({ startDateInputProps, endDateInputProps }) => (
              <>
                <input
                  type="text"
                  {...startDateInputProps}
                  className="at-input at-input--date-icon"
                />
                <input
                  type="text"
                  {...endDateInputProps}
                  className="at-input at-input--date-icon"
                />
              </>
            )}
          </DateRangePicker>
        </div>
      </div>

      <div className="at-separator at-separator--bottom-only at-separator--top-only" />
      <div
        className="atc-step-header"
        style={{ marginTop: 24, paddingBottom: 24 }}
      >
        <h2 className="at-title">{step4_goal_title}</h2>
      </div>
      {step1_predefinedgoals.map((predefinedgoal, index) => (
        <PredefinedField key={index} {...predefinedgoal} index={index} />
      ))}
      {extraFieldAtoms.map((atom, index) => {
        return (
          <ExtraField
            key={atom.toString()}
            atom={atom}
            index={index + step1_predefinedgoals.length}
            delete={() => removeExtraField(atom)}
          />
        );
      })}

      <div
        className="at-add-row at-add-row"
        onClick={() =>
          setExtraFields(prevExtraFields => [
            ...prevExtraFields,
            {
              title: `Extra Goal ${extraFieldAtoms.length + 1}`,
              value: null
            }
          ])
        }
      >
        <img
          src={
            window["mttFinancialAnalysisToolAssets"]?.plusIcon ??
            "/wp-content/themes/ulandssekretariatet/assets/img/icons/plus-icon.svg"
          }
          alt="Add row icon"
          className="at-add-row__image"
        />
        <span className="at-add-row__text">{step1_addextra_string}</span>
      </div>
      <p
        className="at-text-bottom"
        dangerouslySetInnerHTML={{ __html: step4_bottom_text }}
      />
      <div className="atc-button-group atc-button-group--border-top">
        <button className="button white" onClick={prev}>
          {back_string}
        </button>
        <button className="button red" onClick={next}>
          {next_string}
        </button>
      </div>
    </>
  );
}
